import {
  SET_DEBTOR,
  SET_WAGE_SCHEDULE,
  SET_WAGE_DEDUCTION_AUTHORIZATION_DATA,
  CLEAR_WAGE_DEDUCTION_AUTHORIZATION,
} from "actions/wageDebtors";

const initialState = {
  debtor: {},
  wageDeductionAuthorization: {},
  stewardRequestSignatureURL: "",
  clientRequestSignatureURL: "",
  wageSchedule: {},
};

export default function wageDebtors(state = initialState, action) {
  switch (action.type) {
    case SET_DEBTOR:
      return {
        ...state,
        debtor: action.debtor,
      };
    case SET_WAGE_DEDUCTION_AUTHORIZATION_DATA:
      return {
        ...state,
        wageDeductionAuthorization: action.wageDeductionAuthorization,
        stewardRequestSignatureURL: action.stewardRequestSignatureURL,
        clientRequestSignatureURL: action.clientRequestSignatureURL,
      };
    case SET_WAGE_SCHEDULE:
      return {
        ...state,
        wageSchedule: action.wageSchedule,
      };
    case CLEAR_WAGE_DEDUCTION_AUTHORIZATION:
      return {
        ...state,
        wageDeductionAuthorization: {},
      };
    default:
      return state;
  }
}
